export default defineNuxtPlugin(() => {
	const { customPageView } = useGtmEvents();
	const router = useRouter();

	router.afterEach(() => {
		customPageView();
	});
});
